import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Linkedin } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Packages', path: '/packages' },
    { name: 'Book a Call', path: '/book-a-call' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-4 left-4 right-4 md:left-1/2 md:-translate-x-1/2 md:max-w-4xl bg-white/90 backdrop-blur-md rounded-full border border-brand-pale/50 shadow-sm z-50 px-6 py-3">
      <div className="flex justify-between items-center">
        <Link 
          to="/" 
          className="font-serif text-xl font-semibold text-brand-primary hover:text-brand-medium transition-colors"
          data-testid="logo-link"
        >
          Mattoo Consulting
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-6">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              data-testid={`nav-${link.name.toLowerCase()}`}
              className={`text-sm font-medium transition-colors ${
                isActive(link.path)
                  ? 'text-brand-primary'
                  : 'text-muted-foreground hover:text-brand-primary'
              }`}
            >
              {link.name}
            </Link>
          ))}
          <a
            href="https://www.linkedin.com/in/anantmattoo/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="linkedin-link"
            className="text-brand-primary hover:text-brand-medium transition-colors"
          >
            <Linkedin size={20} />
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden text-brand-primary p-2"
          data-testid="mobile-menu-btn"
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden mt-4 pb-4"
          >
            <div className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  data-testid={`mobile-nav-${link.name.toLowerCase()}`}
                  className={`text-sm font-medium py-2 px-4 rounded-full transition-colors ${
                    isActive(link.path)
                      ? 'bg-brand-mist text-brand-primary'
                      : 'text-muted-foreground hover:bg-brand-mist/50'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <a
                href="https://www.linkedin.com/in/anantmattoo/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm font-medium py-2 px-4 text-brand-primary"
              >
                <Linkedin size={18} /> LinkedIn
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
